import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { API } from '../../../api/services';

export const fetchChannelInquiry: any = createAsyncThunk('channelInquiry/fetchChannelInquiry', async (payload) => {
    const response = await API.post(`/get-channel-details-auth`, payload);
    return response?.data;
});

interface channelInquiry {
    singleChannelInquiry: Record<any, any>
    isInquirySent: any
}

const initialState: channelInquiry = {
    singleChannelInquiry: {},
    isInquirySent: null
};

const getSingleChannelInquiry = createSlice({
    name: 'channel-inquiry',
    initialState,
    reducers: {
        setChannelInquiryState: (state, { payload }) => {
            state.singleChannelInquiry = payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchChannelInquiry.fulfilled, (state, action) => {
                state.singleChannelInquiry = action.payload;
                state.isInquirySent = action.payload?.data?.is_inquiry_sent ?? null;

            })
            .addCase(fetchChannelInquiry.rejected, (state, action) => {
                console.error('Failed to fetch channel details:', action.error);
            });
    }
});
export const { setChannelInquiryState } = getSingleChannelInquiry.actions;
export default getSingleChannelInquiry.reducer;